import { useAnalytics, useRequestUrl } from "../hooks";

import { FacebookIcon } from "./icons";
import { GenericShareButton, InnerShareButton } from "./social-sharing.styles";

export type FacebookShareButtonProps = {
    readonly block?: boolean;
    readonly buttonColor?: string;
    readonly buttonText?: string;
    readonly buttonTextColor?: string;
    readonly iconColor?: string;
    readonly shareUrl?: string;
    readonly uuid: string;
    readonly type: string;
};

export const FacebookShareButton = ({
    block = false,
    buttonColor = "#4267B2", //facebook brand blue
    buttonText = "Facebook",
    buttonTextColor = "white",
    iconColor = "white",
    shareUrl,
    uuid,
    type
}: FacebookShareButtonProps) => {
    const { sendTrackEvent } = useAnalytics();
    const requestUrl = useRequestUrl();
    const url = encodeURI(
        `https://www.facebook.com/sharer/sharer.php?u=${shareUrl || requestUrl}`
    );

    return (
        <GenericShareButton
            $block={block}
            $buttonColor={buttonColor}
            $colorOverride={buttonTextColor}
            href={url}
            title="Facebook"
            onClick={() =>
                sendTrackEvent("clickedAnchor", {
                    event: "clicked",
                    eventComponent: "button",
                    eventContainer: type,
                    label: buttonText,
                    labelEnglish: "Facebook",
                    uuid: `${uuid}_facebookButton`,
                    href: url
                })
            }
            data-uuid={`${uuid}_facebookButton`}
        >
            <InnerShareButton>
                <FacebookIcon color={iconColor} />
                <span>{buttonText}</span>
            </InnerShareButton>
        </GenericShareButton>
    );
};
